import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[miqAvoidSpecialChars]',
  standalone: false,
})
export class AvoidSpecialCharsDirective {
  @Input() miqAllowCharacter: string = '';

  @HostListener('keypress', ['$event']) onClick(event) {
    const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);

    if (this.isKeyAllowed(key)) {
      return;
    }

    event.preventDefault();
    return false;
  }

  /**
   * Checks whether a key is allowed without using dynamic RegExp construction.
   *
   * Security: avoids new RegExp(dynamic) entirely — eliminates the ReDoS
   * attack surface:
   *  1. The base alphanumeric check uses a static literal regex.
   *  2. Extra allowed characters are checked via String.includes() — no regex,
   *     no backtracking, no injection risk regardless of what miqAllowCharacter
   *     contains.
   */
  private isKeyAllowed(key: string): boolean {
    // Static literal regex — no dynamic input, no ReDoS risk.
    if (/^[a-zA-Z0-9]$/.test(key)) {
      return true;
    }
    // String.includes() performs a plain substring search — the value of
    // miqAllowCharacter is never interpreted as a regex pattern.
    return this.miqAllowCharacter.length > 0 && this.miqAllowCharacter.includes(key);
  }
}
